import React, { useEffect, useState } from "react";
import {
  FaPlus,
  FaBox,
  FaFilter,
  FaEye,
  FaTrash,
  FaArrowLeft,
  FaArrowRight,
  FaStore,
  FaMoneyBillWave,
  FaTimes,
  FaCheck,
  FaPills,
  FaEdit
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import Swal from "sweetalert2";

const ResepPage = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [drugs, setDrugs] = useState([]);
  const [outlets, setOutlets] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState("");
  const [search, setSearch] = useState("");
  const [hargaStart, setHargaStart] = useState("");
  const [hargaEnd, setHargaEnd] = useState("");
  const [pageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);

  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const storedOutletId = localStorage.getItem("id_outlet");

  // Fetch Outlets
  const fetchOutlets = async () => {
    if (role === "owner") {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/outlet`, {
          headers: { Authorization: `Bearer ${token}` },
          cache: "no-store",
        });
        const data = await response.json();
        setOutlets(data.data || []);
      } catch (error) {
        console.error(error);
      }
    }
  };

  // Fetch Data Paket
  const fetchDrugs = async () => {
    let url = `${process.env.REACT_APP_API_BASE_URL}/v1/drug/pack/list?search=${search}&harga_jual_start=${hargaStart || 0}&harga_jual_end=${hargaEnd || 999999}&page=${page}&per_page=${pageSize}`;
    if (role !== "owner") {
      const outletId = storedOutletId;
      if (!outletId) return;
      url += `&id_outlet=${outletId}`;
    } else if (selectedOutlet) {
      url += `&id_outlet=${selectedOutlet}`;
    }

    try {
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
        cache: "no-store",
      });
      const data = await response.json();
      setDrugs(data.data || []);
      setTotalPages(data.meta?.last_page || 1);
      setTotalData(data.meta?.total || 0);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (role === "owner") fetchOutlets();
    fetchDrugs();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [selectedOutlet, hargaStart, hargaEnd, search]);

  useEffect(() => {
    fetchDrugs();
  }, [page, selectedOutlet, hargaStart, hargaEnd, search]);

  const openFilterModal = () => setIsFilterOpen(true);
  const closeFilterModal = () => setIsFilterOpen(false);

  const handleDeletePaket = async (id, name) => {
    Swal.fire({
      title: `Hapus Paket "${name}"?`,
      text: "Data yang dihapus tidak dapat dikembalikan!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e02424",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
      background: "#fff",
      customClass: {
        popup: "rounded-2xl shadow-xl",
        title: "text-lg font-semibold text-gray-800",
        confirmButton: "rounded-xl px-4 py-2 font-semibold",
        cancelButton: "rounded-xl px-4 py-2 font-semibold",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/v1/drug/pack/delete/${id}`,
            { method: "DELETE", headers: { Authorization: `Bearer ${token}` } }
          );
          const data = await response.json();
          if (response.ok && data.success !== false) {
            Swal.fire({
              icon: "success",
              title: "Berhasil!",
              text: `Paket "${name}" telah dihapus.`,
              timer: 2000,
              showConfirmButton: false,
              background: "#f0fdf4",
            });
            fetchDrugs();
          } else {
            Swal.fire({ icon: "error", title: "Gagal Menghapus", text: data.message || "Terjadi kesalahan.", confirmButtonColor: "#e02424" });
          }
        } catch (error) {
          Swal.fire({ icon: "error", title: "Kesalahan Server", text: "Tidak dapat menghapus paket saat ini.", confirmButtonColor: "#e02424" });
        }
      }
    });
  };

  return (
     <main className="flex-1 min-h-0 flex flex-col px-6 pb-6 bg-green-50 gap-4">
          {/* PANEL */}
          <div className="bg-white rounded-3xl shadow-xl p-6 flex flex-col gap-4">
            {/* Panel Header */}
            <div className="flex items-center gap-3 mb-2">
              <FaBox className="text-green-600 text-3xl" />
              <h1 className="text-3xl font-bold text-gray-800">Paket</h1>
            </div>
            <p className="text-gray-600 mb-4">Kelola semua paket obat dengan mudah dan cepat</p>

      {/* Action & Search */}
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-3">
        <button
          className="px-5 py-2.5 bg-yellow-400 hover:bg-yellow-600 text-white text-sm font-medium rounded-2xl flex items-center gap-2 shadow-md transform hover:scale-105 transition"
          onClick={() => navigate("/obat-paket/paket/create")}
        >
          <FaPlus className="text-base" /> Tambah Paket
        </button>

        <div className="flex items-center gap-3 flex-1 md:flex-none">
          <input
            type="text"
            placeholder="Cari resep..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="flex-1 md:flex-none px-4 py-2 text-sm border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
          />
          <button
            className="bg-white border border-gray-300 px-4 py-2 rounded-2xl shadow-sm hover:bg-gray-100 flex items-center gap-2 text-sm font-medium transform hover:scale-105 transition"
            onClick={openFilterModal}
          >
            <FaFilter className="text-blue-500" /> Filter
          </button>
        </div>
      </div>

      {/* Table Panel */}
        <div className="overflow-y-auto bg-white rounded-2xl border border-gray-200 shadow">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="sticky top-0 z-10 bg-green-100">
            <tr>
              {["No", "Nama Resep", "Tuslah", "Embalase", "Harga Jual", "Outlet", "Total Item", "Aksi"].map(
                (head) => (
                  <th key={head} className="px-4 py-3 border-b font-semibold text-left">
                    {head}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {drugs.map((item, index) => {
              const nameFormatted = item.name.replace(/\s+/g, "_");
              const outletFormatted = item.outlet.replace(/\s+/g, "_");
              return (
                <tr key={item.id} className="hover:bg-gray-50 border-b border-gray-100 transition">
                  <td className="px-4 py-3">{(page - 1) * pageSize + index + 1}</td>
                  <td className="px-4 py-3 font-medium text-gray-800">{item.name}</td>
                  <td className="px-4 py-3">
                    Rp {item.tuslah?.toLocaleString("id-ID", { minimumFractionDigits: 2 }) || "0"}
                  </td>
                  <td className="px-4 py-3">
                    Rp {item.embalase?.toLocaleString("id-ID", { minimumFractionDigits: 2 }) || "0"}
                  </td>
                  <td className="px-4 py-3">
                    Rp {item.harga_jual?.toLocaleString("id-ID", { minimumFractionDigits: 2 }) || "0"}
                  </td>
                  <td className="px-4 py-3">{item.outlet}</td>
                  <td className="px-4 py-3">{item.total_item}</td>
                  <td className="px-4 py-3 flex gap-2">
                    
                    {/* LIHAT */}
                    <button
                      className="p-2 bg-green-100 hover:bg-green-200 rounded-lg shadow-md text-green-600 hover:text-green-700 transition transform hover:scale-110"
                      title="Lihat"
                      onClick={() => navigate(`/obat-paket/paket/detail/${nameFormatted}/${outletFormatted}`)}
                    >
                      <FaEye />
                    </button>

                    {/* edit*/}
                   <button
                    className="p-2 bg-blue-100 hover:bg-blue-200 rounded-lg text-blue-600"
                    title="Edit"
                    onClick={() => {
                      const nameFormatted = item.name.replace(/\s+/g, "_")
                      const outletFormatted = item.outlet.replace(/\s+/g, "_")

                      navigate(`/obat-paket/paket/update/${nameFormatted}/${outletFormatted}`)
                    }}
                  >
                    <FaEdit />
                  </button>
                    {/* HAPUS */}
                    <button
                      className="p-2 bg-red-100 hover:bg-red-200 rounded-lg shadow-md text-red-600 hover:text-red-700 transition transform hover:scale-110"
                      title="Hapus"
                      onClick={() => handleDeletePaket(item.id, item.name)}
                    >
                      <FaTrash />
                    </button>

                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

      </div>
      
        {/* Pagination */}
        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-gray-500">
            Menampilkan {drugs.length} dari total {totalData} resep
          </p>
          <div className="flex items-center space-x-2">
            <button
              className="flex items-center px-3 py-1 text-sm bg-green-100 hover:bg-gray-200 text-gray-700 rounded-2xl shadow-md transform hover:scale-105 transition"
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              disabled={page === 1}
            >
              <FaArrowLeft /> Sebelumnya
            </button>
            <span className="text-sm text-gray-600">
              Halaman <strong>{page}</strong> dari <strong>{totalPages}</strong>
            </span>
            <button
              className="flex items-center px-3 py-1 text-sm bg-green-100 hover:bg-gray-200 text-gray-700 rounded-2xl shadow-md transform hover:scale-105 transition"
              onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={page === totalPages}
            >
              Selanjutnya <FaArrowRight />
            </button>
          </div>
        </div>

      {/* Modal Filter */}
      <Modal
        isOpen={isFilterOpen}
        onRequestClose={closeFilterModal}
        className="bg-white rounded-3xl shadow-2xl p-6 w-full max-w-md mx-auto mt-24 relative"
        overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-start z-50"
        ariaHideApp={false}
      >
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
          <FaFilter className="text-green-600" /> Filter Obat Paket
        </h2>

        {role === "owner" && (
          <div className="mb-5">
            <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
              <FaStore className="text-gray-500" /> Outlet
            </label>
            <select
              className="w-full px-4 py-2 border border-gray-300 rounded-2xl focus:ring-2 focus:ring-green-300 focus:outline-none"
              value={selectedOutlet}
              onChange={(e) => setSelectedOutlet(e.target.value)}
            >
              <option value="">Semua Outlet</option>
              {outlets.map((outlet) => (
                <option key={outlet.id} value={outlet.id}>
                  {outlet.name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="mb-6">
          <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center gap-2">
            <FaMoneyBillWave className="text-gray-500" /> Range Harga
          </label>
          <div className="flex items-center gap-3">
            <input
              type="number"
              placeholder="Mulai..."
              className="w-full px-4 py-2 border border-gray-300 rounded-2xl"
              value={hargaStart}
              onChange={(e) => setHargaStart(e.target.value)}
            />
            <span className="text-gray-500">-</span>
            <input
              type="number"
              placeholder="Akhir..."
              className="w-full px-4 py-2 border border-gray-300 rounded-2xl"
              value={hargaEnd}
              onChange={(e) => setHargaEnd(e.target.value)}
            />
          </div>
        </div>

        <div className="flex justify-between gap-3">
          <button
            onClick={closeFilterModal}
            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-2 rounded-2xl flex justify-center items-center gap-2 transition"
          >
            <FaTimes /> Batal
          </button>
          <button
            className="flex-1 bg-green-500 hover:bg-green-600 text-white font-semibold py-2 rounded-2xl flex justify-center items-center gap-2 transition"
            onClick={() => {
              setPage(1);
              fetchDrugs();
              closeFilterModal();
            }}
          >
            <FaCheck /> Terapkan Filter
          </button>
        </div>
      </Modal>
    </div>
     </main>
  );
};

export default ResepPage;
